import { useMutation, useQuery, useQueryClient } from '@zg-rentals/react-query5';

import {
  RentalManagerPropertyConditionWebApiHandler_addToPropertyConditionWaitlist,
  RentalManagerPropertyConditionWebApiHandler_getIsOnPropertyConditionWaitlist,
} from '@zg-rentals/rental-manager-env';
import { useRentalManagerUserPropertySummaryWebApiHandler_propertyConditions } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import TimeConstants from '../../../srcLegacy/shared/constants/TimeConstants';

const IS_ON_PROPERTY_CONDITION_WAITLIST = 'isOnPropertyConditionWaitlist';

export const usePropertyConditionsSummary = (listingAlias: string) =>
  useRentalManagerUserPropertySummaryWebApiHandler_propertyConditions(
    { listingAlias },
    {
      enabled: Boolean(listingAlias),
      staleTime: TimeConstants.SECONDS_8,
      retry: false,
      meta: {
        tags: ['propertyConditionsSummary'],
        context: {
          api: 'rentalManager',
          details: 'useRentalManagerUserPropertySummaryWebApiHandler_propertyConditions',
        },
      },
    },
  );

export const useIsOnPropertyConditionWaitlistQuery = (listingAlias: string) => {
  return useQuery({
    queryKey: [IS_ON_PROPERTY_CONDITION_WAITLIST, { listingAlias }],
    queryFn: () => RentalManagerPropertyConditionWebApiHandler_getIsOnPropertyConditionWaitlist({ listingAlias }),
    select: (data) => data?.isOnWaitlist,
    enabled: Boolean(listingAlias),
  });
};

export const useAddToPropertyConditionWaitlistMutation = (listingAlias: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => RentalManagerPropertyConditionWebApiHandler_addToPropertyConditionWaitlist({ listingAlias }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [IS_ON_PROPERTY_CONDITION_WAITLIST, { listingAlias }] });
    },
  });
};
